import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {catchError, map, retry} from 'rxjs/operators';
import {Router} from '@angular/router';
import {NotificationsService} from 'angular2-notifications';

@Injectable()
export class HttpClientService {

    private httpOptions = { 'Content-Type': 'application/x-www-form-urlencoded' };

    constructor(private http: HttpClient, private router: Router, private notificationService: NotificationsService) {
    }

    get<T>(path, httpOptions?: any): Observable<T> {
        return this.http.get<T>(path, { headers: httpOptions, observe: 'response' })
            .pipe(
                map(response => response.body),
                retry(0),
                catchError(this.handleError.bind(this))
            );
    }

    delete<T>(path, httpOptions): Observable<T> {
        return this.http.delete<T>(path, { headers: httpOptions, observe: 'response' })
            .pipe(
                map(response => response.body),
                retry(0),
                catchError(this.handleError.bind(this))
            );
    }

    post<T>(rota, body: any, httpOptions): Observable<T> {
        return this.http.post<T>(rota, body, { headers: httpOptions, observe: 'response' }).pipe(
            map(response => response.body),
            retry(0),
            catchError(this.handleError.bind(this))
        );
    }

    put<T>(rota, body: any, httpOptions): Observable<T> {
        return this.http.put<T>(rota, body, { headers: httpOptions, observe: 'response' }).pipe(
            map(response => response.body),
            retry(0),
            catchError(this.handleError.bind(this))
        );
    }

    handleError(error: any) {
        if (error.status === 401) {
            localStorage.removeItem('cookie');
            localStorage.removeItem('usuario');
            this.notificationService.error('Login inválido', 'Verique seus dados e tente novamente.');
        } else if (error.status === 400) {
            if (error.error) {
                this.notificationService.error('Erro', error.error.message);
            }
        } else if (error.status === 500) {
            if (error.error) {
                this.notificationService.error('Erro', error.error.message);
            }
        } else {
            this.notificationService.error('Erro', 'Ocorreu algum erro inesperado.');
        }

        return throwError(error);
    }

}
